import React, { Component } from 'react'
import styles from "./WallPaperBtn.module.css"

import GRID_COLOR_ICON_SRC from "../static/icons8-color-58.png"
export default class WallPaperBtn extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectFlag: false
        }
    }

    clickHandler = (e) => {

        this.setState(state => { return { selectFlag: !state.selectFlag } }, () => {
            if (this.props.clickCallback)
                this.props.clickCallback(this.state.selectFlag)
        })
    }
    render() {
        var style = { background: "" }
        if (this.state.selectFlag) {
            style.background = "#11aaFF"
        }
        return (
            <div className={styles.wallPaperStyle} style={style} onClick={this.clickHandler}>
                <img src={GRID_COLOR_ICON_SRC} alt="" />
            </div>
        )
    }
}
